<div class="smart-menu-web" id="smartMenu">
    <nav class="main-menu" [ngClass]="{'mainmenuHeight': isBranchAdminUser || isOfficeManagerSearchClicked,
        'lobMenu': isLOBUser}">
        <ul>
            <div>
            <li class="has-subnav" (click)="onHomeClick($event)">
                <div>
                    <img src="{{assetsUrl}}Icon-metro-home.svg" alt="portal-home" title="" href="">
                    <span class="nav-text">
                        Home
                    </span>
                </div>
              
            </li>
            </div> 
            <div [ngClass]="{'cursorAuto2': isPortalManagerClicked}" *ngIf="!isLOBUser">
                <li [ngClass]="{'cursorAuto': isPortalManagerClicked}" class="has-subnav" (click)="onPortalManagerClick($event)">
                    <div>
                        <img src="{{assetsUrl}}noun_manager.svg" alt="noun-manager" title="" href="">
                        <span class="nav-text">
                            Portal Manager
                        </span>
                    </div>
                    
                </li>
            </div>
            <div>
            <li class="has-subnav" (click)="onListClick($event)" *ngIf="!isLOBUser">
                <div>
                    <img src="{{assetsUrl}}wandlistingImg.svg" alt="portal-home" title="" href="">
                    <span class="nav-text">
                        Website & Listings
                    </span>
                </div>
            
            </li>
            </div>
            <div *ngIf="!isBranchAdminUser && !isOfficeManagerSearchClicked && !isLOBUser" [ngClass]="{'cursorAuto2': isCoreServiceClicked}">
            <li class="has-subnav" (click)="onCoreServiceClick($event)"  [ngClass]="{'cursorAuto': isCoreServiceClicked}">
                <div>
                    <img src="{{assetsUrl}}core-serviceImg.svg" alt="portal-home" title="" href="">
                    <span class="nav-text">
                        Core services
                    </span>
                </div>
               
            </li>
            </div>
        </ul>
    </nav>
</div>
<div class="smart-menu-responsive" >
    <div class="btnHolder smart-menu-footer-fixed">
      <div class="responsive-smartMenu">
        <div [ngClass]="{'home-smart-menu-lob': isLOBUser}">
            <img  [src]="homeSrc" alt="portal-home" title="" href="" (click)="onHomeClick($event)">
           <p>Home</p>
        </div>
        <div *ngIf="!isLOBUser">
            <img [src]="imgSrc"  alt="noun-manager" title="" href="" (click)="onPortalManagerClick($event)">
            <p [ngClass]="{'blue-text':isPortalManagerClicked}">Agent Portal<br><span class="">Manager</span> </p>
        </div>
        <div *ngIf="!isLOBUser">
            <img [src]="imgSrcWeb" alt="portal-home" title="" href="" (click)="onListClick($event)">
            <p>Website &<br> <span class="">Listings</span></p>
        </div>
        <div *ngIf="!isBranchAdminUser && !isOfficeManagerSearchClicked && !isLOBUser">
            <img [src]="coreImg" alt="portal-home" title="" href="" (click)="onCoreServiceClick($event)">
            <p [ngClass]="{'blue-text': isCoreServiceClicked}">Core service<br> <span class="">Assosciations</span></p>
        </div>
      </div>
  </div>
</div>



<app-search-update-confirmation
[customClass]="'custom-modal'"
[okBtnLabel]="'Yes'"
[cancelBtnLabel]="'No'"
(onConfirm)="onHomeClickConfirm()"
  #homeClickModal
>
</app-search-update-confirmation>
<app-search-update-confirmation
[customClass]="'custom-modal'"
[okBtnLabel]="'Yes'"
[cancelBtnLabel]="'No'"
(onConfirm)="onPortalClickConfirm()"
  #portalClickModal
>
</app-search-update-confirmation>
<app-search-update-confirmation
[customClass]="'custom-modal'"
[okBtnLabel]="'Yes'"
[cancelBtnLabel]="'No'"
(onConfirm)="onCoreServiceClickConfirm()"
  #coreClickModal
>
</app-search-update-confirmation>